import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ModalDialogModule } from 'ngx-modal-dialog';

import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ModalComponent } from './components/modal/modal.component';
import { AgmCoreModule } from '@agm/core';
import { DndListModule } from 'ngx-drag-and-drop-lists';
import { LocationTypeaheadComponent } from './components/location-typeahead/location-typeahead.component';
import { AgmDirectionModule } from 'agm-direction';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { FooterComponent } from './components/footer/footer.component';
import { MomentModule } from 'ngx-moment';
import { ModalModule, PaginationModule } from 'ngx-bootstrap';
import { LocationModal } from './components/location-modal/location-modal.component';
import { NgbdSortableHeader } from './components/sortable/sortable.directive';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TagInputModule } from 'ngx-chips';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { AgmOverlays } from 'agm-overlays';

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		ReactiveFormsModule,
		ModalDialogModule.forRoot(),
		LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR }),
		LoadingModule.forRoot({
			animationType: ANIMATION_TYPES.threeBounce,
			backdropBackgroundColour: 'rgba(0, 0, 0, 0.1)',
			primaryColour: '#343A40',
			secondaryColour: '#343A40',
			tertiaryColour: '#343A40'
		}),
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyBPR0k7lgPacXwdcuw62MBxa5iujLHqhNk'
		}),
		AgmOverlays,
		AgmDirectionModule,
		DndListModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		MomentModule.forRoot({
			relativeTimeThresholdOptions: {
				'm': 59
			}
		}),
		ModalModule.forRoot(),
		PaginationModule.forRoot(),
		NgMultiSelectDropDownModule.forRoot(),
		NgxChartsModule,
		TagInputModule,
		InfiniteScrollModule,
		SelectDropDownModule
	],
	exports: [
		// Shared Modules
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		LoadingModule,
		AgmCoreModule,
		AgmOverlays,
		DndListModule,
		AgmDirectionModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		MomentModule,
		ModalModule,
		PaginationModule,
		NgMultiSelectDropDownModule,
		NgxChartsModule,
		TagInputModule,
		InfiniteScrollModule,
		SelectDropDownModule,
			// Shared Components
		LocationTypeaheadComponent,
		NavbarComponent,
		SidebarComponent,
		ModalComponent,
		LocationTypeaheadComponent,
		FooterComponent,
		LocationModal,
		NgbdSortableHeader
	],
	entryComponents: [
		ModalComponent,
		LocationModal
	],
	declarations: [
		NavbarComponent,
		SidebarComponent,
		ModalComponent,
		LocationTypeaheadComponent,
		FooterComponent,
		LocationModal,
		NgbdSortableHeader
	],
	providers: []
})
export class SharedModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/shared.module.ts